import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Single-value arche filter persisted in the URL (`?arche=`). Empty string =
 * "all". The literal 'system' means Fias-system issues (untagged). Persisting in
 * the URL keeps the filter across open-detail→back and reload, like the status
 * filter.
 */
export function useArcheFilterParam(): {
  arche: string;
  setArche: (value: string) => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const arche = searchParams.get('arche') ?? '';

  const setArche = useCallback(
    (value: string) => {
      setSearchParams(
        (prev) => {
          const p = new URLSearchParams(prev);
          if (value) p.set('arche', value);
          else p.delete('arche');
          return p;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return { arche, setArche };
}
